<script setup>
import { WButton, WTextfield, WTitle } from '@alice-health/wonderland-vue'
import { ref } from 'vue'
import JsonViewer from 'vue-json-viewer'

import { channelsInstance } from '@/api/instances'

const id = ref(undefined)
const items = ref(undefined)
const getHistory = async () => {
  items.value = await channelsInstance.get(`/debug/routing_history/${id.value}`)
}
</script>

<template>
  <div class="debug__grid">
    <div class="debug__form">
      <WTitle size="small" class="debug__input">
        Histórico de Roteirização
      </WTitle>

      <WTextfield v-model="id" label="Model Id" class="debug__input" />
      <WButton class="debug__cta" block @click="getHistory">
        Buscar Histórico
      </WButton>
    </div>
    <div v-if="items" class="debug__results">
      <JsonViewer class="debug__json" :value="items" :expand-depth="2" />
    </div>
  </div>
</template>
